<div class="main-page-content">
  <div class="main-page-content-block">



    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 [multiSortMeta]="[{field: 'LastUserMessage', order: -1}, {field: 'DateCreated', order: -1}]"
                 sortMode="multiple"
                 [(selection)]="selectedItems"
                 (selectionChange)="onSelectionChange($event)"
                 [expandedRowKeys]="expandedRows"
                 (onRowExpand)="onRowExpand($event)"
                 (onRowCollapse)="onRowCollapse($event)"
                 [filters]="{DateClosed: [{ value: '0D', matchMode: 'isNull', operator: 'and'}]}">

          <ng-template pTemplate="caption">
            <div class="d-flex justify-content-end ">

              <div class="p-2 flex-fill"><h1 class="content-heading-font">Support Tickets</h1></div>
              <div class="ml-auto">
                <button class="btn btn-primary " (click)="showLinkGitHubSelected()" title="Link Github Issue">
                  <i class="pi pi-paperclip" [ngClass]="{'pi-spin': loading}"></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="selectedAll()" title="Select All">
                  <i class="pi pi-list-check" ></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="selectedNone()" title="Select None">
                  <i class="pi pi-list" ></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="expandAll()" title="Expand All">
                  <i class="pi pi-plus-circle" ></i>
                </button>
                &nbsp;
                <button class="btn btn-secondary " (click)="collapseAll()" title="Collapse All">
                  <i class="pi pi-minus-circle"></i>
                </button>
                &nbsp;
                <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
                  <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn  " (click)="toggleAssignedToMe()" title="Assigned to me"
                        [class.btn-info]="showOnlyAssignedToMe"
                      [class.btn-outline-info]="!showOnlyAssignedToMe">
                  <i class="pi pi-user" ></i>
                </button>
                &nbsp;
                <button class="btn btn-outline-info " (click)="toggleWatchedByMe()" title="Watched by me"
                      [class.btn-info]="showOnlyWatchedByMe"
                      [class.btn-outline-info]="!showOnlyWatchedByMe">
                  <i class="pi pi-eye"></i>
                </button>
                &nbsp;
                <button class="btn btn-outline-info " (click)="togglePinByMe()" title="Pinned by me"
                      [class.btn-info]="showOnlyPinByMe"
                      [class.btn-outline-info]="!showOnlyPinByMe">
                  <i class="pi pi-bookmark"></i>
                </button>
                &nbsp;
                <button class="btn btn-outline-info " (click)="toggleUnreadOnly()" title="Unread only"
                      [class.btn-info]="showUnreadOnly"
                      [class.btn-outline-info]="!showUnreadOnly">
                  <i class="pi pi-envelope" ></i>
                </button>
                &nbsp;
                <button class="btn btn-outline-info " (click)="toggleOpenOnly()" title="Show only open"
                      [class.btn-info]="showOpenOnly"
                      [class.btn-outline-info]="!showOpenOnly">
                  <i class="pi pi-check-square" ></i>
                </button>
                &nbsp;
                <button class="btn btn-outline-info " (click)="toggleCriticalOnly()" title="Show only critical"
                      [class.btn-info]="showCriticalOnly"
                      [class.btn-outline-info]="!showCriticalOnly">
                  <i class="pi pi-exclamation-triangle" ></i>
                </button>
                &nbsp;
                <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
                  <i class="pi pi-filter-slash"></i>
                </button>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-end d-none d-xxl-table-cell" style="width:70px;">#</th>
              <th class="text-center" style="width:70px;"></th>
              <th pSortableColumn="DateCreated" class="text-center  d-none  d-xl-table-cell text-nowrap " style="width: 150px;">
                Created<p-sortIcon field="DateCreated"></p-sortIcon>
                <p-columnFilter type="date" field="DateCreated" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="LastUpdated" class="text-center  d-none  d-xxl-table-cell text-nowrap " style="width:150px;">
                Updated<p-sortIcon field="LastUpdated"></p-sortIcon>
                <p-columnFilter type="date" field="LastUpdated" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="LastUserMessage" class="text-center d-none d-md-table-cell text-nowrap " style="width: 170px;">
                Last Message<p-sortIcon field="LastUserMessage"></p-sortIcon>
                <p-columnFilter type="date" field="LastUserMessage" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="DateClosed" class="text-center d-none d-xxxl-table-cell text-nowrap " style="width:160px;">
                Closed  <p-sortIcon field="DateClosed"></p-sortIcon>
                <p-columnFilter type="date" field="DateClosed" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="SupportTicketType" class="text-start d-none d-xxl-table-cell text-nowrap " style="min-width:210px;">
                Type
                <p-sortIcon field="SupportTicketType"></p-sortIcon>
                <p-columnFilter field="SupportTicketTypeID"  matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="supportTicketTypes" placeholder="Any" (onChange)="filter($event.value)" optionValue="Value" optionLabel="Label" [filter]="false">
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="SupportTicketStatus" class="text-start d-none d-xxl-table-cell text-nowrap " style="min-width:210px;">
                Status
                <p-sortIcon field="SupportTicketStatus"></p-sortIcon>
                <p-columnFilter field="SupportTicketStatusID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="supportTicketStatuses" placeholder="Any" (onChange)="filter($event.value)" optionValue="Value" optionLabel="Label" [filter]="false">
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="SupportTicketPriority" class="text-start d-none d-xxl-table-cell text-nowrap " style="min-width:210px;">
                Priority
                <p-sortIcon field="SupportTicketPriority"></p-sortIcon>
                <p-columnFilter field="SupportTicketPriorityID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="supportTicketPriorities" placeholder="Any" (onChange)="filter($event.value)" optionValue="Value" optionLabel="Label" [filter]="false">
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="Client_Name" class="text-start d-none d-lg-table-cell text-nowrap " style="min-width: 130px;">
                Submitter<p-sortIcon field="Client_Name"></p-sortIcon>
                <p-columnFilter type="text" field="Client_Name" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="GitHub_IssueNumber" class="text-center d-none  d-xl-table-cell text-nowrap ">
                GitHub<p-sortIcon field="GitHub_IssueNumber"></p-sortIcon>
                <p-columnFilter type="numeric" field="GitHub_IssueNumber" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="GitHub_Status" class="text-start d-none d-xxl-table-cell text-nowrap ">
                GitHub Status<p-sortIcon field="GitHub_Status"></p-sortIcon>
                <p-columnFilter type="text" field="GitHub_Status" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Subject" class="text-start d-none d-md-table-cell text-nowrap " style="min-width: 160px;">
                Subject<p-sortIcon field="Subject"></p-sortIcon>
                <p-columnFilter type="text" field="Subject" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-expanded="expanded">
            <tr>
              <th class="text-end d-none d-xxl-table-cell">
                <a href="#" [routerLink]="['/tickets/'+  item.ID ]">
                  {{ item.ID |  number }}
                </a>
              </th>
              <td class="text-center text-nowrap ">
                <div style="height: 2.357rem; vertical-align: middle; display: inline-block " class="me-2">
                  <p-tableCheckbox [value]="item" />
                </div>
                <p-button type="button" pRipple [pRowToggler]="item" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
              </td>
              <td class="text-center text-nowrap  d-none  d-xl-table-cell">
                <span title="{{ item.DateCreated | date: 'short' }}"> {{ getTimeFromNow(item.DateCreated) }}</span>
              </td>
              <td class="text-center text-nowrap  d-none  d-xxl-table-cell">
                <span title="{{ item.LastUpdated | date: 'short' }}"> {{ getTimeFromNow(item.LastUpdated) }}</span>
              </td>
              <td class="text-center text-nowrap d-none d-md-table-cell ">
                <span title="{{ item.LastUserMessage | date: 'short' }}"> {{ getTimeFromNow(item.LastUserMessage) }}</span>
                <span class="badge bg-info badge-info badge-pill ms-2" title="Unread" *ngIf="item.UnreadCount">{{ item.UnreadCount }}</span>
              </td>
              <td class="text-center text-nowrap  d-none  d-xxxl-table-cell  ">
                <span title="{{ item.DateClosed | date: 'short' }}"> {{ getTimeFromNow(item.DateClosed) }}</span>
              </td>
              <td class=" text-break d-none d-xxl-table-cell text-truncate  " style="max-width: 10vw;">
                <span class="{{getSupportTicketTypeClass(item)}}">
                  {{ item.SupportTicketType  }}
                </span>
              </td>
              <td class=" text-break d-none d-xxl-table-cell text-truncate  " style="max-width: 10vw;">

                {{ item.SupportTicketStatus }}
                <span *ngIf="item.DateClosed" class="text-primary" >(Closed)</span>
              </td>
              <td class=" text-break d-none d-xxl-table-cell text-truncate  " style="max-width: 10vw;">
                {{ item.SupportTicketPriority  }}
                <span *ngIf="item.IsCritical" class="text-primary">(Critical)</span>
              </td>
              <td class=" d-none d-lg-table-cell text-break text-truncate " style="max-width: 10vw;">
                {{ item.Client_Name}} [{{ item.Client}}]
              </td>
              <td class="text-center d-none  d-xl-table-cell ">
                <a href="https://github.com/UTBS/{{ item?.GitHub_Repository }}/issues/{{ item?.GitHub_IssueNumber }}">
                  {{ item.GitHub_IssueNumber |  number  }}
                </a>
              </td>
              <td class=" d-none d-xxl-table-cell text-break text-truncate " style="max-width: 10vw;">
                {{ item.GitHub_Status }}
              </td>
              <td class="text-break  text-truncate " style="max-width: 20vw;">
                <a href="#" [routerLink]="['/tickets/'+  item.ID ]">
                  {{ item.Subject }}
                </a>
              </td>

            </tr>
          </ng-template>


          <ng-template pTemplate="expandedrow" let-item>
            <tr>
              <td colspan="12">
                <div class="card w-100">
                  <div class="card-body">
                    <h5 class="card-title">#{{ item.ID }} {{item.Subject }}</h5>
                    <h6 class="card-subtitle mb-2 text-muted">
                      {{formatMountainTime(item.DateCreated)}}
                    </h6>
                  </div>

                  <ul class="list-group list-group-flush ">

                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <b>Type </b> <span class="ms-2">{{ item.SupportTicketType }} </span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <b>Status</b>
                      <span class="ms-2">{{ item.SupportTicketStatus }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <b>Priority</b>
                      <span class="ms-2">{{ item.SupportTicketPriority }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <b>Client</b>
                      <span class="ms-2">{{ item.Client }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <b>Submitter</b>
                      <span class="ms-2">{{ item.Client_Name }} [{{ item.Client_UserID }}]</span>
                      <span class="ms-2">{{ item.Client_PhoneNumber }}</span>
                      <span class="ms-2">{{ item.Client_UserEmail }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <b>Last User Message</b><span class="ms-2">
                        {{formatMountainTime(item.LastUserMessage) }}
                        <span class="badge bg-info badge-info badge-pill" *ngIf="item.UnreadCount">{{ item.UnreadCount }}</span>
                      </span>

                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <b>Last Staff Message</b><span class="ms-2">  {{formatMountainTime(item.LastUpdated) }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="item.DateClosed">
                      <b>Date Closed</b><span class="ms-2">  {{formatMountainTime(item.DateClosed) }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="item.ParentTicketID">
                      <b>Parent Ticket</b>
                      <a class="ms-2" href="#" [routerLink]="['/tickets/'+  item.ID ]">
                        #{{ item.ParentTicketID |  number }} {{item.ParentTicketName }}
                      </a>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="item.GitHub_IssueNumber">
                      <b>GitHub Issue</b>
                      <span class="ms-2">{{ item.GitHub_Status }}</span>
                      <a href="https://github.com/UTBS/{{ item?.GitHub_Repository }}/issues/{{ item?.GitHub_IssueNumber }}" target="_blank">
                        {{ item?.GitHub_Repository }} #{{ item.GitHub_IssueNumber |  number  }}
                      </a>
                    </li>
                  </ul>
                  <div class="card-footer d-flex justify-content-center ">
                    <button class="btn btn-primary me-2" type="button" id="btnGithub" [class.button-loading]="loading" (click)="showLinkGitHub(item)">GitHub Issue</button>
                    <a href="#" class="btn btn-primary me-2" [routerLink]="['/tickets/'+  item.ID ]">View</a>

                  </div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10">No items found.</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>
</div>




<p-dialog header="Link GitHub Issue" [modal]="true" [(visible)]="gitHubIssueVisible">
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubIssue">Issue</label><br />
      <select id="gitHubIssue" [(ngModel)]="gitHubIssue" [class.div-loading]="loadingGitHubIssue" class="form-control">
        <option *ngFor="let issue of gitHubIssues" [ngValue]="issue">
          {{issue.repository}} -  {{issue.number}} -  {{issue.title}}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubComment">Comment</label><br />
      <input type="text" id="gitHubComment" [(ngModel)]="gitHubComment" class="form-control" />
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnGithubConfirm" [class.button-loading]="loading" (click)="linkGitHub()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnGithubCancel" [class.button-loading]="loading" (click)="gitHubIssueVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>
